import { Component, OnInit } from "@angular/core";
import { LayoutComponent } from "../../shared/layout/layout.component";
import { SpinnerComponent } from "../../shared/icons/spinner/spinner.component";
import { GigyaService } from "../../services/gigya.service";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { VersionService, Version } from "../../services/version.service";

@Component({
  selector: "app-logout",
  standalone: true,
  imports: [LayoutComponent, SpinnerComponent],
  templateUrl: "./logout.component.html",
  styleUrl: "./logout.component.css",
})
export class LogoutComponent implements OnInit {
  constructor(
    private gigyaService: GigyaService,
    private router: Router,
    private versionService: VersionService,
  ) { }

  public async ngOnInit(): Promise<void> {
    await this.gigyaService.execute(this.gigyaService.client.accounts.logout, {});

    const redirectUri = this.getPostLogoutRedirectUri();
    if (redirectUri) {
      window.location.href = redirectUri;
    } else {
      window.location.href = this.versionService.current === Version.B2C ? environment.fallbackUrlB2C : environment.fallbackUrlB2B;
    }
  }

  private getPostLogoutRedirectUri(): string | null {
    const searchParams = new URLSearchParams(window.location.search);
    const uri = searchParams.get("post_logout_redirect_uri");
    if (!uri) {
      return null;
    }
    try {
      const url = new URL(uri);
      const domain = url.hostname;
      if (domain === "ns.nl" || domain.endsWith(".ns.nl") || domain === "nsinternational.com" || domain.endsWith(".nsinternational.com")) {
        return uri;
      }
      console.error("Redirection blocked: domain not allowed", domain);
      return null;
    } catch (e) {
      console.error("Invalid redirect URL", uri);
      return null;
    }
  }
}
